import { render, staticRenderFns } from "./card-synonym.vue?vue&type=template&id=28991c50&"
import script from "./card-synonym.vue?vue&type=script&lang=js&"
export * from "./card-synonym.vue?vue&type=script&lang=js&"
import style0 from "./card-synonym.vue?vue&type=style&index=0&id=28991c50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports